<template>
	<Transition name="fade">
		<div class="cco-catalogVariant" v-if="isOpen" @keyup.esc="close()">
			<div class="cco-catalogVariant__background" @click="close()"></div>
			<div class="cco-catalogVariant__content">
				<div class="header">
					<div class="header__info">
						<h2>{{ translations["Please choose variant"] }}</h2>
					</div>
					<div class="header__close" @click="close()">
						<CloseIcon></CloseIcon>
					</div>
				</div>

				<div class="variants">
					<div class="variants__wrapper">
						<div
							class="variants__variant"
							:class="{
								'variants__variant--selected': selectedVariant.id == variant.id,
							}"
							v-for="variant in data"
							:key="variant.id"
							@click="selectedVariant = variant"
						>
							<div
								class="o-radio"
								:class="{
									'o-radio--selected': selectedVariant.id == variant.id,
								}"
							>
								<div class="o-radio__dot"></div>
							</div>
							<div class="info">
								<img :src="variant.image.src" :alt="variant.title" />
								<p>{{ variant.title }}</p>
							</div>

							<PriceObject v-if="variant.price" :price="variant.price" />
						</div>
					</div>
				</div>
				<div class="footer">
					<h2 class="footer__price">
						{{
							selectedVariant.price?.onSale
								? selectedVariant.price?.saleAsCurrency
								: selectedVariant.price?.priceAsCurrency
						}}
					</h2>
					<CartAddPurchasable
						:id="selectedVariant.id"
						:stock="selectedVariant.stock"
					/>
				</div>
			</div>
		</div>
	</Transition>
</template>

<script>
import { mapState } from "vuex";
import CloseIcon from "@web/assets/icon/close.svg";
import PriceObject from "@/vue/components/objects/PriceObject.vue";
import CartAddPurchasable from "../../objects/CartAddPurchasable.vue";

export default {
	name: "CatalogVariant",
	components: {
		CloseIcon,
		PriceObject,
		CartAddPurchasable,
	},
	props: {},
	data: () => {
		return {
			selectedVariant: {},
		};
	},
	computed: {
		...mapState({
			isOpen: (state) => state.status.variantSelector,
			data: (state) => state.status.variantData,
		}),
	},
	watch: {
		data: {
			deep: true,
			handler(value) {
				if (this.isOpen) {
					this.selectedVariant = this.data[0];
					document.addEventListener("keydown", this.keyHandler);
				}
			},
		},
	},
	methods: {
		close() {
			document.removeEventListener("keydown", this.keyHandler);
			this.$store.dispatch("status/closeVariantSelector");
		},

		keyHandler: function (e) {
			if (e.key === "Escape" && this.isOpen) {
				this.close();
				return;
			}
		},
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.cco-catalogVariant {
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	position: fixed;
	z-index: 100;

	display: flex;
	justify-content: center;
	align-items: center;

	&__background {
		position: absolute;
		background-color: $c-overlay;
		width: 100%;
		height: 100%;
		z-index: 1;
	}

	&__content {
		background-color: $c-white;
		pointer-events: all;
		width: 100%;
		height: 450px;
		max-width: 585px;
		z-index: 2;

		.header {
			display: flex;
			padding: 22px 24px 16px 40px;
			justify-content: space-between;
			gap: 16px;
			border-bottom: $e-border;

			&__info {
				h2 {
					margin-bottom: 4px;
				}
			}

			&__close {
				cursor: pointer;
				width: 35px;
				height: 35px;
				display: flex;
				justify-content: flex-end;

				svg {
					margin-top: 4px;
					width: 16px;
					height: 16px;
				}

				transition: $t-hover;
				&:hover {
					transition: $t-hover;
					opacity: 0.5;
				}
			}
		}

		.variants {
			@include scroll-custom();
			height: 250px;
			padding-inline: 24px;
			overflow-y: auto;

			&__wrapper {
				padding-top: 25px;
				display: flex;
				flex-direction: column;
				gap: 8px;
			}

			&__variant {
				cursor: pointer;
				transition: $t-hover;
				border: $e-border;
				border-radius: 3px;
				display: flex;
				align-items: center;
				padding: 8px 24px 8px 16px;
				gap: 12px;

				.info {
					display: flex;
					align-items: center;
					flex: 1;

					img {
						@include size-fix(56px, 56px);
						margin-right: 8px;
					}

					p {
						@include text-overflow(1);
						text-transform: uppercase;
					}
				}

				&--selected {
					transition: $t-hover;
					border: 1px solid $c-blue;
				}
			}
		}

		.footer {
			height: 100px;
			border-top: $e-border;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-inline: 24px;

			&__price {
				padding-right: 30px;

				h2 {
					font-weight: $f-semibold;
				}
			}

			.c-cartAddPurchasable {
				display: flex;
				flex: 1;

				&__actions {
					display: flex;
					flex: 1;
				}
			}

			.o-btn {
				flex: 1;
			}
		}
	}
}
</style>
